/** Runtime configuration sourced from Vite environment variables.
 * Values are injected at build time by the deploy script writing frontend/.env.{mode}.
 * For local development, set these in frontend/.env.local.
 */
const defaultFeatureFlags: AppFeatureFlags = {
  contacts: true,
  districts: true,
  ministries: true,
  auditLog: true,
  carparkControl: true,
  carparkPhoneNumbers: true,
  carparkLog: true,
  userManagement: true,
  cookbook: true,
};

function parseFeatureFlags(value?: string): AppFeatureFlags {
  if (!value || value === 'null') return defaultFeatureFlags;

  try {
    const parsed = JSON.parse(value) as Partial<AppFeatureFlags>;
    return {
      contacts: parsed.contacts ?? defaultFeatureFlags.contacts,
      districts: parsed.districts ?? defaultFeatureFlags.districts,
      ministries: parsed.ministries ?? defaultFeatureFlags.ministries,
      auditLog: parsed.auditLog ?? defaultFeatureFlags.auditLog,
      carparkControl: parsed.carparkControl ?? defaultFeatureFlags.carparkControl,
      carparkPhoneNumbers: parsed.carparkPhoneNumbers ?? defaultFeatureFlags.carparkPhoneNumbers,
      carparkLog: parsed.carparkLog ?? defaultFeatureFlags.carparkLog,
      userManagement: parsed.userManagement ?? defaultFeatureFlags.userManagement,
      cookbook: parsed.cookbook ?? defaultFeatureFlags.cookbook,
    };
  } catch {
    console.warn('Invalid VITE_FEATURE_FLAGS_JSON value; using default feature flags.');
    return defaultFeatureFlags;
  }
}

export const runtimeConfig: AppRuntimeConfig = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:3000',
  userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN ?? '',
  appUrl: import.meta.env.VITE_APP_URL ?? 'http://localhost:5173',
  appVersion: import.meta.env.VITE_APP_VERSION ?? 'local',
  appEnv: import.meta.env.VITE_APP_ENV ?? 'dev',
  featureFlags: parseFeatureFlags(import.meta.env.VITE_FEATURE_FLAGS_JSON),
};

export function getRuntimeConfig(): AppRuntimeConfig {
  return runtimeConfig;
}
